function hasMany(type) {
  return function (target, key) {
    if (!target.constructor.relationships) {
      target.constructor.relationships = [];
    }
    target.constructor.relationships.push({
      modelName: new hasMany.HasManyRelation(type),
      propertyName: key,
    });
  };
}

hasMany.HasManyRelation = class HasManyRelation {
  constructor(modelName) {
    this.className = modelName;
  }
};

export default hasMany;
